// Imports
import formatPhoneNumber from '../../../utils/format-phone-number';
import htmlEncodeTemplateLiteral from '../../../utils/sanitizing/html-encode-template-literal';


// Types
export type PrintableAccount = {
	name: string;
	typeName?: string;
	addresses: {
		formatted: string;
		homePhone?: string | null;
	}[];
	members: {
		name: string;
		designation?: string | null;
		phone?: string | null;
		email?: string | null;
	}[];
};

interface Options {
	searchQuery: string;
	callingCode: number;
	noAddressesText: string;
}


/** Builds the HTML for printing a list of accounts, with each account's addresses beside its members */
export default function buildAccountsPrintHTML(accounts: PrintableAccount[], options: Options) {
	// Form HTML content for printing
	let htmlContent =
		"<body style=\"font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\">";
	
	htmlContent +=
		options.searchQuery.length > 0
			? htmlEncodeTemplateLiteral`<h3 style="font-size: 1.5rem; margin-top: 1.25rem; margin-bottom: 0.5313rem; font-weight: 500; line-height: 1.1;">Showing results for “${options.searchQuery}”</h3>`
			: '';
	
	for (const account of accounts) {
		htmlContent += '<div style="border-bottom: 2px solid #ddd; margin-bottom: 16px; break-inside: avoid;">';
		
		htmlContent += htmlEncodeTemplateLiteral`<h4 style="margin: 0;">${account.name}</h4>`;
		htmlContent += account.typeName ? htmlEncodeTemplateLiteral`<small>${account.typeName}</small><br>` : '';
		htmlContent += '<br>';
		htmlContent += '<div style="display: flex;">';
		htmlContent += '<div style="flex-shrink: 0; width: 250px; padding-right: 30px;">';
		
		for (const address of account.addresses) {
			htmlContent += htmlEncodeTemplateLiteral`${{
				dontEncode: true,
				text: htmlEncodeTemplateLiteral`${address.formatted}`.replace(/\n/g, '<br>'),
			}}<br>`;
			
			htmlContent += address.homePhone
				? htmlEncodeTemplateLiteral`<small>&nbsp;&nbsp;&nbsp;&nbsp;&rdsh; ${formatPhoneNumber(address.homePhone, options.callingCode)}</small><br>`
				: '';
			
			htmlContent += '<br>';
		}
		
		if (account.addresses.length === 0) {
			htmlContent += htmlEncodeTemplateLiteral`<em>${options.noAddressesText}</em><br>`;
		}
		
		htmlContent += '</div>';
		htmlContent += '<div>';
		
		for (const member of account.members) {
			htmlContent += htmlEncodeTemplateLiteral`${member.name}`;
			htmlContent += member.designation
				? htmlEncodeTemplateLiteral`<small><em>&nbsp;&nbsp;(${member.designation})</em></small>`
				: '';
			
			htmlContent += '<br>';
			htmlContent += member.phone
				? htmlEncodeTemplateLiteral`<small>&nbsp;&nbsp;&nbsp;&nbsp;&rdsh; ${formatPhoneNumber(member.phone, options.callingCode)}</small><br>`
				: '';
			
			htmlContent += member.email
				? htmlEncodeTemplateLiteral`<small>&nbsp;&nbsp;&nbsp;&nbsp;&rdsh; ${member.email}</small><br>`
				: '';
		}
		
		htmlContent += '<br>';
		htmlContent += '</div>';
		htmlContent += '</div>';
		htmlContent += '</div>';
	}
	
	if (accounts.length === 0) {
		htmlContent += '<em>No results found…</em>';
	}
	
	htmlContent += '</body>';
	
	
	// Return
	return htmlContent;
}
